if (!Object.groupBy) {
  Object.groupBy = function <K extends PropertyKey, T>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K,
  ): Partial<Record<K, T[]>> {
    // Null prototype like the native one, so a key such as "constructor" isn't already there.
    const result = Object.create(null) as Partial<Record<K, T[]>>;
    let index = 0;
    for (const item of items) {
      const key = keySelector(item, index++);
      const group = result[key] ?? [];
      group.push(item);
      result[key] = group;
    }
    return result;
  };
}
